import {
  arrayUnion,
  deleteField,
  type DocumentReference,
  type Transaction,
} from 'firebase/firestore';
import type {
  CommunicationEventData,
  ExpenseEntryData,
  TimeEntryData,
} from '@shared/types';
import { cleanDataToFirestore } from './converters';

export interface SourceEntryCommunicationCleanupQuery {
  phoneCall(id: string): DocumentReference<CommunicationEventData>;
  textMessage(id: string): DocumentReference<CommunicationEventData>;
}

export const clearDeletedSourceEntryCommunicationLink = async (props: {
  query: SourceEntryCommunicationCleanupQuery;
  transaction: Transaction;
  entryType: 'timeEntry' | 'expenseEntry';
  entryId: string;
  source: TimeEntryData | ExpenseEntryData;
}) => {
  if (props.entryType !== 'timeEntry') return;
  await clearDeletedTimeEntryCommunicationLink({
    query: props.query,
    transaction: props.transaction,
    entryId: props.entryId,
    timeEntry: props.source as TimeEntryData,
  });
};

export const clearDeletedTimeEntryCommunicationLink = async (props: {
  query: SourceEntryCommunicationCleanupQuery;
  transaction: Transaction;
  entryId: string;
  timeEntry: TimeEntryData;
}) => {
  if (
    props.timeEntry.sourceRecord?.type !== 'talkroute' ||
    !props.timeEntry.sourceRecord.communicationEventId
  ) {
    return;
  }
  const communicationRef =
    props.timeEntry.sourceRecord.recordType === 'call'
      ? props.query.phoneCall(props.timeEntry.sourceRecord.communicationEventId)
      : props.query.textMessage(
          props.timeEntry.sourceRecord.communicationEventId,
        );
  const communicationSnapshot = await props.transaction.get(communicationRef);
  if (communicationSnapshot.data()?.timeEntry !== props.entryId) return;
  const timestamp = new Date();
  props.transaction.update(
    communicationRef,
    cleanDataToFirestore({
      timeEntry: deleteField(),
      updatedTimestamp: timestamp,
      events: arrayUnion({
        type: 'modified',
        timestamp,
        userId: props.timeEntry.user,
        details: `timeEntry cleared after deleting ${props.entryId}`,
      }),
    } as unknown as Partial<CommunicationEventData>),
  );
};
